module.exports = __webpack_public_path__ + "static/media/3DPPA10.6dc6a6c6.jpg";